<div class="global-stats" *ngIf="personalStats">
    <!-- | async as personalStats -->
    <div class="stat" [ngClass]="!surveyStats.satisfaction ? muted : ''">
        <span class="label">Satisfacción</span>
        <span class="value">{{
            surveyStats.satisfaction ? surveyStats.satisfaction + "%" : "--"
        }}</span>
    </div>
    <div class="stat" [ngClass]="!surveyStats.responseQuantity ? muted : ''">
        <span class="label">Respuestas</span>
        <span class="value">{{
            surveyStats.responseQuantity
                ? surveyStats.responseQuantity + "%"
                : "--"
        }}</span>
    </div>

    <mat-divider class="separator opacity-1" [vertical]="true"></mat-divider>

    <div class="stat" [ngClass]="!personalStats.hour ? muted : ''">
        <span class="label">Últ. hora</span>
        <span class="value">{{
            personalStats.hour ? personalStats.hour + "%" : "--"
        }}</span>
    </div>

    <div class="stat" [ngClass]="!personalStats.day ? muted : ''">
        <span class="label">Día</span>
        <span class="value">{{
            personalStats.day ? personalStats.day + "%" : "--"
        }}</span>
    </div>

    <div class="stat" [ngClass]="!personalStats.week ? muted : ''">
        <span class="label">Semana</span>
        <span class="value">{{
            personalStats.week ? personalStats.week + "%" : "--"
        }}</span>
    </div>

    <div class="stat" [ngClass]="!personalStats.month ? muted : ''">
        <span class="label">Mes</span>
        <span class="value">{{
            personalStats.month ? personalStats.month + "%" : "--"
        }}</span>
    </div>
    
    <button mat-icon-button [matTooltip]="'Recargar estadísticas. Última actualización: ' + lastUpdate" (click)="getEstadisticas()" >
        <mat-icon
        class="icon-size-4 dark:white "
            [svgIcon]="'heroicons_outline:arrow-path'"
        ></mat-icon>
    </button>
</div>
